{#if filterArray.length}
    <button on:click="{() => dispatch('fetchResults')}"
            class="py-2 px-4 bg-blue-drkn text-white rounded shadow focus:outline-none flex hover:bg-sky-500 transition">
        Abfrage ausführen
        <svg class="scale-75 fill-white ml-1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M3 22v-20l18 10-18 10z"/>
        </svg>
    </button>

    {#if results.data}

        <div class="my-8 text-xl">{results.data.length} von {results.total} Ergebnissen</div>

        <div class="rounded">
            <table class="table-auto border w-full mt-6">
                <thead>
                <tr class="bg-gray-50 text-left">
                    <th class="p-3 px-4">Name</th>
                    {#if resource === 'pois'}
                        <th class="p-3 px-4">Name 2</th>
                        <th class="p-3 px-4">PLZ</th>
                        <th class="p-3 px-4">Stadt</th>
                    {/if}
                    {#if resource === 'events'}
                        <th class="p-3 px-4">Name 2</th>
                        <th class="p-3 px-4">POI Name</th>
                        <th class="p-3 px-4">Startdatum</th>
                        <th class="p-3 px-4">Enddatum</th>
                        <th class="p-3 px-4">POI PLZ</th>
                        <th class="p-3 px-4">POI Stadt</th>
                    {/if}
                    {#if resource === 'routes'}
                        <th class="p-3 px-4">Name 2</th>
                    {/if}
                    {#if resource === 'public_transport_lines'}
                        <th class="p-3 px-4">Eigener Name</th>
                        <th class="p-3 px-4">Beschreibung</th>
                    {/if}
                    {#if resource === 'public_transport_stops'}
                        <th class="p-3 px-4">Eigener Name</th>
                    {/if}
                </tr>
                </thead>
                <tbody>
                {#each results.data as result}
                    <tr class="border-t odd:bg-gray-50">
                        <td class="p-2 px-4">{result.name}</td>
                        {#if resource === 'pois'}
                            <td class="p-2 px-4">{result.name_2 || ''}</td>
                            <td class="p-2 px-4">{result.address.postal_code || ''}</td>
                            <td class="p-2 px-4">{result.address.city || ''}</td>
                        {/if}
                        {#if resource === 'events'}
                            <td class="p-2 px-4">{result.name_2 || ''}</td>
                            <td class="p-2 px-4">{result.poi.name}</td>
                            <td class="p-2 px-4">{formatDate(result.start_datetime)}</td>
                            <td class="p-2 px-4">{formatDate(result.end_datetime)}</td>
                            <td class="p-2 px-4">{result.poi.address.postal_code || ''}</td>
                            <td class="p-2 px-4">{result.poi.address.city  || ''}</td>
                        {/if}
                        {#if resource === 'routes'}
                            <td class="p-2 px-4">{result.name_2 || ''}</td>
                        {/if}
                        {#if resource === 'public_transport_lines'}
                            <td class="p-2 px-4">{result.own_name || ''}</td>
                            <td class="p-2 px-4">{result.description || ''}</td>
                        {/if}
                        {#if resource === 'public_transport_stops'}
                            <td class="p-2 px-4">{result.own_name || ''}</td>
                        {/if}
                    </tr>
                {/each}
                </tbody>
            </table>
        </div>

    {/if}
{/if}

<script>
    import {createEventDispatcher} from "svelte";

    let dispatch = createEventDispatcher();

    export let results;

    export let filterArray;

    export let resource;

    function formatDate(rawDate) {
        const date = new Date(rawDate);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear().toString();

        return `${day}.${month}.${year}`;
    }

</script>